<div class="tree-root">
  @if(nodes.length === 0) {
    <div class="tree-header">
      <ion-button 
        size="small" 
        fill="clear" 
        (click)="addRootNode()">
        <ion-icon slot="start" name="add"></ion-icon>
        {{ 'TREE.ADD_ROOT_NODE' | translate }}
      </ion-button>
    </div>
  }

  <div class="tree-content">
    <div class="header-row">
      <div class="node-column">
        {{ field.props.label || '' | translate }}
      </div>
      @for (statHook of statsHooks; track statHook.label) {
        <div class="stat-column">
          {{ statHook.label | translate }}
        </div>
      }
    </div>
    <tree-root
      [nodes]="nodes"
      [(state)]="treeState"
      [options]="treeOptions">
      <ng-template #treeNodeWrapperTemplate let-node let-index="index">
        <div class="body-row">
          <div class="node-column">
            <div class="node-wrapper-outer" [attr.data-level]="node.level">
              <div class="branch-lines"></div>
              <div class="node-wrapper" [style.padding-left]="node.getNodePadding()">
                <tree-node-expander [node]="node"></tree-node-expander>
              @if (editingNodeId !== node.id) {
                <div class="node"
                  (click)="node.mouseAction('click', $event)"
                  (dblclick)="node.mouseAction('dblClick', $event)"
                  (contextmenu)="node.mouseAction('contextMenu', $event)"
                  (treeDrop)="node.onDrop($event)"
                  [treeAllowDrop]="node.allowDrop"
                  [treeDrag]="node"
                  [treeDragEnabled]="node.allowDrag()"
                  (mouseover)="mouseOverNode(node)"
                  (mouseleave)="mouseLeaveNode(node)">
                  <span class="node-name">
                    <tree-node-content [node]="node" [index]="index"></tree-node-content>
                    <!-- {{ node.data.name }} -->
                  </span>
                  @if(hoveringNodeId === node.data.id) {
                    <div class="node-actions">
                      <ion-icon (click)="startEditNode(node)" 
                        class="edit-icon"
                        slot="icon-only" 
                        name="create-outline">
                      </ion-icon>
                      @if (getNodeLevel(node) < 5) {
                        <ion-icon slot="icon-only" 
                          class="add-icon"
                          name="add" 
                          (click)="addChildNode(node)">
                        </ion-icon>
                      }
                      @if(canDeleteNode(node)) {
                        <ion-icon slot="icon-only" 
                          class="delete-icon"
                          name="trash-outline" 
                          (click)="deleteNode(node)">
                        </ion-icon>
                      }
                    </div>
                  }
                </div>
              } @else {
                <div class="mode-editing">
                  <input class="node-input"
                    [(ngModel)]="editingNodeName"
                    (keydown.enter)="saveNodeEdit(node)"
                    (keydown.escape)="cancelEdit()"
                    (blur)="saveNodeEdit(node)"
                    placeholder="{{ 'TREE.NEW_NODE_NAME' | translate }}"
                    type="text"
                    autofocus />
                </div>
              }
              </div>
            </div>
          </div>
          @for (statHook of statsHooks; track statHook.label) {
            <div class="stat-column">
              <span>
                {{ statHook.hookFunction(node, statHook.code, statHook.rollup) | localeNumber:'compact':'0.0-1':'' }}
              </span>
            </div>
          }
        </div>
      </ng-template>
    </tree-root>

    <!-- @if (nodes.length === 0) {
      <div class="empty-state">
        <ion-icon name="add"></ion-icon>
        <p>{{ 'TREE.TREE_EMPTY_MESSAGE' | translate }}</p>
      </div>
    } -->
  </div>
</div>
